import { UpperCasePipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxAddressComponent,
  OnyxDatePipe,
  OnyxNamePipe,
  OnyxPhonePipe,
} from '@onyx/angular';
import { DateTime } from 'luxon';
import { AuthStore } from '../../../../../../../../../auth/common/stores/auth.store';
import type { Order } from '../../../../../../../common/interfaces/order';

@Component({
  selector: 'app-order-pdf-template-contractors',
  imports: [
    TranslatePipe,
    UpperCasePipe,
    OnyxDatePipe,
    OnyxAddressComponent,
    OnyxNamePipe,
    OnyxPhonePipe,
  ],
  templateUrl: './order-pdf-template-contractors.component.html',
  styleUrl: './order-pdf-template-contractors.component.scss',
})
export class OrderPdfTemplateContractorsComponent {
  private readonly authStore = inject(AuthStore);

  public readonly order = input.required<Order>();

  protected readonly I18N = 'orders.pdfTemplate';

  protected business = this.authStore.business()!;
  protected today = DateTime.now().toISO();
}
